import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { ButtonVariant } from '@brg/ui'
import { API, Endpoints } from '@brg/api'
import { useModal } from 'core'
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal'
import { Wrapper, Title, Description, ButtonRow, ActionButton, CloseWrapper } from '../EnrollCourseModal/styles'

interface FormCourseSuccessModalProps {
  teamId?: string
}

export const FormCourseSuccessModal: FC<FormCourseSuccessModalProps> = ({ teamId = '' }) => {
  const modal = useModal()
  const history = useHistory()

  const handleClose = () => {
    modal.hide()
  }

  const handleLeave = async () => {
    try {
      await API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/LMS/RemoveMemberFromExternalCourse')
        .body({ teamId })
        .post()
        .send()
    } catch (err) {
      console.error('[FormCourseSuccessModal] leave course error', err)
    }
    modal.hide()
  }

  return (
    <Wrapper>
      <CloseWrapper>
        <IconCloseMob onClick={handleClose} />
      </CloseWrapper>

      <Title>Спасибо за проявленный интерес к курсу!</Title>
      <Description>
        Ваша заявка на курс отправлена организаторам. С вами обязательно свяжутся.
      </Description>

      <ButtonRow>
        <ActionButton width={220} variant={ButtonVariant.Filled} onClick={handleClose}>
          Закрыть
        </ActionButton>
        <ActionButton width={220} variant={ButtonVariant.Filled} onClick={handleLeave}>
          Покинуть курс
        </ActionButton>
      </ButtonRow>
    </Wrapper>
  )
}
import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { ButtonVariant } from '@brg/ui'
import { API, Endpoints } from '@brg/api'
import { useModal } from 'core'
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal'
import { Wrapper, Title, Description, ButtonRow, ActionButton, CloseWrapper } from '../EnrollCourseModal/styles'

interface FormCourseSuccessModalProps {
  teamId?: string
}

export const FormCourseSuccessModal: FC<FormCourseSuccessModalProps> = ({ teamId = '' }) => {
  const modal = useModal()
  const history = useHistory()

  const handleClose = () => {
    modal.hide()
  }

  const handleLeave = async () => {
    try {
      await API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/LMS/RemoveMemberFromExternalCourse')
        .body({ teamId })
        .post()
        .send()
    } catch (err) {
      console.error('[FormCourseSuccessModal] leave course error', err)
    }
    modal.hide()
  }

  return (
    <Wrapper>
      <CloseWrapper>
        <IconCloseMob onClick={handleClose} />
      </CloseWrapper>

      <Title>Спасибо за проявленный интерес к курсу!</Title>
      <Description>
        Ваша заявка на курс отправлена организаторам. С вами обязательно свяжутся.
      </Description>

      <ButtonRow>
        <ActionButton width={220} variant={ButtonVariant.Filled} onClick={handleClose}>
          Закрыть
        </ActionButton>
        <ActionButton width={220} variant={ButtonVariant.Filled} onClick={handleLeave}>
          Покинуть курс
        </ActionButton>
      </ButtonRow>
    </Wrapper>
  )
}
